import { useQuery } from 'react-query'
import { useParams } from 'react-router-dom'
import { showError } from '_metronic/helpers'
import { PageHeading } from 'app/components'
import { getAtendimentoById } from 'app/modules/apps/atendimento/core/_requests'

/**
 * Cabeçalho da tela de logs de um atendimento, acima do <TableCard>: protocolo como título;
 * paciente e data da solicitação como apoio.
 */
export const LogsAtendimentoHeading = () => {
  const { id } = useParams<{ id: string }>()

  const { data: atendimento, isError } = useQuery(
    ['logs-atendimento-atual', id],
    () => getAtendimentoById(Number(id)),
    { enabled: Boolean(id), refetchOnWindowFocus: false, onError: showError }
  )

  const titulo = atendimento?.protocolo
    ? `Atendimento ${atendimento.protocolo}`
    : isError
    ? 'Atendimento'
    : 'Carregando atendimento…'
  const descricao = [atendimento?.paciente?.nome, atendimento?.solicitacaoFormatada]
    .filter(Boolean)
    .join(' · ')

  return <PageHeading title={titulo} description={descricao || undefined} />
}
